import { render, staticRenderFns } from "./ProductActionDeleteImage.vue?vue&type=template&id=452a1188&"
import script from "./ProductActionDeleteImage.vue?vue&type=script&lang=ts&"
export * from "./ProductActionDeleteImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports